import { EstadoNutricional } from 'types/enums'

import { ParametrosImc } from '../calculateEstadoNutricional'
import imcGestante from '../parametros/imcGestante.json'

interface SemanasParametrosImcGestante {
  [x: number]: ParametrosImc
}

export function getEstadoNutricionalGestante(imc: number, semanaGestacional: number) {
  const paramsSemana = getParametrosParaSemanaGestacional(semanaGestacional)

  if (imc <= paramsSemana.baixo.maximo) {
    return EstadoNutricional.BAIXO_PESO
  } else if (imc >= paramsSemana.adequado.minimo && imc <= paramsSemana.adequado.maximo) {
    return EstadoNutricional.ADEQUADO
  } else if (imc >= paramsSemana.sobrepeso.minimo && imc <= paramsSemana.sobrepeso.maximo) {
    return EstadoNutricional.SOBREPESO.WARNING
  } else {
    return EstadoNutricional.OBESIDADE.DANGER
  }
}

export function getParametrosParaSemanaGestacional(semana: number): ParametrosImc {
  return (imcGestante as SemanasParametrosImcGestante)[semana]
}
